import {
  useStyle
} from "@/classify"

import defaultClasses from "./gallery.module.css"
import GalleryItemShimmer from "./item.shimmer"

const GalleryShimmer = (props) => {
  const {
    items = [], itemProps = {} 
  } = props
  const classes = useStyle(defaultClasses, props.classes)

  return (
    <div className={classes.root} aria-live='polite' aria-busy='true'>
      <div className={classes.items}>
        {items.map((item, index) => (
          <GalleryItemShimmer key={index} {...itemProps} />
        ))}
      </div>
    </div>
  )
}

export default GalleryShimmer
